// testService.js
import api from "./api";

export const getQuestions = (subscription_id, user_id) => {
     try{
          return api.get(`/test/get_questions/${subscription_id}/${user_id}`, {
               requiresAuth: true
          });
     }catch (error) {
         console.error('Error fetching details:', error);
         throw error;
     }
};

export const startSession = (data) => {
     try{
          return api.post(`/test/start-session`, data ,{
               requiresAuth: true
          });
     }catch (error) {
         console.error('Error fetching details:', error);
         throw error;
     }
};

export const getSessionDetail = (session_id) => {
     try{
          return api.get(`/test/session/${session_id}`, {
               requiresAuth: true
          });
     }catch (error) {
         console.error('Error fetching details:', error);
         throw error;
     }
};

export const saveAns = (session_id, data) => {
     try{
          return api.put(`/test/session/${session_id}/answer`, data,{
               requiresAuth: true
          });
     }catch (error) {
         console.error('Error fetching details:', error);
         throw error;
     }
};

export const submit_test = (session_id, data) => {
     try{
          return api.post(`/test/session/${session_id}/submit`, data, {
               requiresAuth: true
          });
     }catch (error) {
         console.error('Error fetching details:', error);
         throw error;
     }
};